import React from 'react';
import CivitripClientForm from './containers/CivitripClientForm';
var ModuleCivitrip = (function (props) {
    return (React.createElement(CivitripClientForm, null));
});
export default ModuleCivitrip;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/Civitrip/ModuleCivitrip.tsx
// module id = 1583
// module chunks = 0